/**
 * TanStack Router: /onboarding/:id
 *
 * This route file was auto-generated by the route generation script.
 * Component: OnboardingDetailPage
 * Layout: Authenticated (_auth)
 *
 * @see scripts/generate-routes.ts
 * @see docs/architecture/tanstack-router-migration-architecture.md
 */
import { createFileRoute } from '@tanstack/react-router'
import OnboardingDetailPage from '@/app/onboarding/[id]/page'

/**
 * Route: /onboarding/:id
 * Layout: _auth (authenticated)
 * Component: OnboardingDetailPage
 */
export const Route = createFileRoute('/_auth/onboarding/$id')({
  component: OnboardingDetailPage,
})
